import * as React from 'react';
// modules
import LoadingManager from '../modules/loading-manager';
import RootComposer from 'modules/root-composer';
import RedemptionError from '../modules/redemption/redemption-error';
// components
import {
    RouterCodeFirst,
    RouterPlatformFirst,
    RouterPickYourContent
} from '../router';
import Header from 'components/header/header.container';
import Content from 'components/content';
import Footer from 'modules/footer';
import ErrorBoundary from 'components/error-boundary';
import StandaloneOnly from 'modules/standalone-only';
// types
import { ILoginSession } from 'types/session';
import IConfig from '@sitegen/common/constants/config';
import { IGenericFunction } from 'types/generics';
import { WIDGET_NAME } from '@sitegen/common/constants';

const routerOptions = {
    [WIDGET_NAME.CF_REDEEM]: <RouterCodeFirst />,
    [WIDGET_NAME.PYC_REDEEM]: <RouterPickYourContent />,
    default: <RouterPlatformFirst />,
};

export const Root: React.FC<IRootProps> = props => (
    <RootComposer>
        <StandaloneOnly mode={props.config.mode}>
            <Header />
        </StandaloneOnly>
        <LoadingManager>
            <Content>
                <ErrorBoundary fallbackComponent={<RedemptionError/>}>
                    {routerOptions[props.config.widgetName] || routerOptions.default}
                </ErrorBoundary>
            </Content>
            <StandaloneOnly mode={props.config.mode}>
                <Footer
                    availablePlatforms={props.config.platformSelection}
                    activeLanguageCode={props.activeLanguageCode}
                    availableLanguageTags={props.config.availableLanguages}
                    fetchLanguage={props.fetchLanguage}
                />
            </StandaloneOnly>
        </LoadingManager>
    </RootComposer>
);

Root.displayName = 'Root';

interface IRootProps {
    readonly config: IConfig;
    readonly loginSession: ILoginSession;
    readonly activeLanguageCode: string;
    readonly logOut: IGenericFunction<void>;
    readonly fetchLanguage: IGenericFunction<void, string>;
}

export default Root;
